import "./Footer.css";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../Services/AppInsightService";

interface IProps {
}

const Footer: React.FC<IProps> = () => {
    return (
        <div className="App-footer">
            Copyright stuff goes here
        </div>
    );
}

export default withAITracking(reactPlugin, Footer);
